import { render } from "./ExecuteKick.vue?vue&type=template&id=215ee627"
import script from "./ExecuteKick.vue?vue&type=script&lang=js"
export * from "./ExecuteKick.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__